import React, { useState } from "react";
import Modal from "react-modal";
import { Dropdown } from "primereact/dropdown";
import { InputSwitch } from "primereact/inputswitch";
import chatGptLogo from "../assets/images/chatgpt-logo.png";

interface AIQueryFormProps {
  isOpen: boolean;
  onRequestClose: () => void;
  aiTopic: string;
  setAiTopic: (topic: string) => void;
  handleAiQuery: (includeMapDetails: boolean) => void;
}

const AIQueryForm: React.FC<AIQueryFormProps> = ({
  isOpen,
  onRequestClose,
  aiTopic,
  setAiTopic,
  handleAiQuery,
}) => {
  const customStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.6)",
    },
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      width: "50%",
      height: "65%",
      borderRadius: "10px",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "#fff",
    },
  };

  const [includeMapDetails, setIncludeMapDetails] = useState<boolean | null>(
    null
  );
  const options = [
    { name: "Do not include further details", code: false },
    { name: "Include map details", code: true },
  ];

  return (
    <Modal
      isOpen={isOpen}
      style={customStyles}
      onRequestClose={onRequestClose}
      contentLabel="AI Query Modal"
    >
      <div className="ai-query-modal-content">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "5px",
            marginBottom: "-5px",
          }}
        >
          <img
            src={chatGptLogo}
            alt="ChatGPT Logo"
            style={{ width: "50px", height: "50px", marginRight: "10px" }}
          />
          <div className="ai-query-title">ChatGPT</div>
        </div>
        <label className="ai-query-label">
          Ask AI about any topic of interest:
        </label>
        <div className="card ai-include-map-details">
          <Dropdown
            value={options.find((option) => option.code === includeMapDetails)}
            onChange={(e) => setIncludeMapDetails(e.value.code)}
            options={options}
            optionLabel="name"
            placeholder="Include Map Details?"
            className=""
          />
        </div>
        <textarea
          className="ai-query-modal-input"
          placeholder="Enter topic here..."
          spellCheck="false"
          value={aiTopic}
          onChange={(e) => setAiTopic(e.target.value)}
          rows={5}
        />
        <div className="ai-buttons">
          <button
            className="modal-button-left"
            onClick={() => handleAiQuery(includeMapDetails ?? false)}
          >
            Query
          </button>
          <button className="modal-button-left" onClick={onRequestClose}>
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default AIQueryForm;
